import React from 'react';
import { connect } from 'dva';
import { Spin } from 'antd';
import styles from './LoadingPage.less';

export default function wrap(WrappedComponent) {
  class LoadingPage extends React.Component {
    componentDidMount() {
      const { dispatch } = this.props;

      dispatch({ type: 'user/fetchCurrent' }).then(() => {
        dispatch({ type: 'global/fetchMenus' });
      });
    }

    render() {
      const { menus, loading } = this.props;

      if (menus.length === 0 || loading) {
        return (
          <div className={styles.root}>
            <Spin size="large" />
          </div>
        );
      } else {
        return <WrappedComponent {...this.props} />;
      }
    }
  }

  return connect(({ global, loading }) => ({
    menus: global.menus,
    loading: loading.effects['global/fetchMenus'],
  }))(LoadingPage);
}



// WEBPACK FOOTER //
// ./src/layouts/LoadingPage.js